import { Directive, inject } from '@angular/core';
import { IS_CARD_PROCESS } from '../../../process';
import { TemplateAssertDirective } from '../template-assert.directive';

/**
 * @description
 * a structural directive used to assert a template unique to CARD process. it implements
 * a boolean "isMatch" method to assert the match to the specific product (card), when a match
 * is made, the template will be rendered, otherwise - no content is rendered
 */

@Directive({
  standalone: true,
  selector: '[isCardProcess]'
})
export class IsCardProcessDirective extends TemplateAssertDirective {
  override readonly isMatch$$ = inject(IS_CARD_PROCESS);
}
